export const GAM_NETWORK_CODE = 'gam_network_code'
export const GAM_TRAFFICKER_ID = 'gam_trafficker_id'
